module.exports = __webpack_public_path__ + "img/pro-xtIcon10.821dbbda.png";